module.exports = __webpack_public_path__ + "img/0-02-0a-dd5144747b4fe2897ff7d5231273bd50c67571ea8cfbce3c8347f1bb7da61742_70249329.8557b832.jpg";